export default __webpack_public_path__ + "static/media/Smartbox_Logo_neg.bfb2ec75.svg";